import { render, staticRenderFns } from "./ModuloNoDisponible.vue?vue&type=template&id=15f3daf8"
import script from "./ModuloNoDisponible.vue?vue&type=script&lang=js"
export * from "./ModuloNoDisponible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports